import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import React from 'react';
import Body from './Body';
import Header from './Header';
import { Outlet } from 'react-router';

interface IGenericLayout {
  pages?: string[]; 
  links?: string[];
  appName?: string;
}

const useStyles = makeStyles<Theme>((theme) => ({
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    backgroundColor: '#f6f6f6',
    fontFamily: 'sans-serif',
  },
}));

const GenericLayout: React.FC<React.PropsWithChildren<IGenericLayout>> = ({
  pages,
  links,
  appName,
}) => {
  const styles = useStyles();
  return (
    <div className={styles.mainContainer}>
      <Header  pages={pages} links={links} appName={appName}/>
      <Body>
        <Outlet />
      </Body>
    </div>
  );
};

export default GenericLayout;
